<script setup>
import { useI18n } from 'vue-i18n'
const { t: $t } = useI18n()
import NavigationMenu from '@/components/miscellaneous/NavigationMenu.vue'

defineProps({
    projectName: { type: String, default: 'Boligvegler' },
    projectLogo: { type: String, default: null },
    projectLink: { type: String, default: '' },
    projectColor: { type: String, default: '#ededed' },
    projectSlug: { type: String, default: '#' }
})
</script>
<template>
    <div class="top-navigation" :class="`bg-${projectColor}`" :style="{ background: projectColor }">
        <ClientOnly>
            <v-container fluid class="d-flex align-center justify-space-between dynamic-max-width">
                <div class="left d-flex align-center">
                    <NuxtLink :to="`${projectLink}`" class="title-link">
                        <img v-if="projectLogo" height="32px" :src="projectLogo" />
                        <span v-else class="project-title text-h6">{{ projectName }}</span>
                    </NuxtLink>
                </div>
                <!-- <div class="center d-flex justify-center align-center flex-grow-1"></div> -->
                <v-spacer></v-spacer>
                <NavigationMenu :projectSlug="projectSlug" />
            </v-container>
        </ClientOnly>
    </div>
</template>
<style scoped>
.dynamic-max-width {
    max-width: 1800px;
}

.top-navigation .dynamic-max-width {
    padding-left: 0;
}

@media screen and (min-width: 1200px) {
    .top-navigation .dynamic-max-width {
        max-width: 1200px;
    }
}

@media screen and (min-width: 1600px) {
    .top-navigation .dynamic-max-width {
        padding-left: 10px;
        max-width: 1600px;
    }
}

@media screen and (min-width: 1768px) {
    .top-navigation .dynamic-max-width {
        padding-left: 10px;
        max-width: 1768px;
    }
}

@media screen and (min-width: 2000px) {
    .top-navigation .dynamic-max-width {
        padding-left: 10px;
        max-width: 2000px;
    }
}

@media screen and (max-width: 960px) {
    .top-navigation .dynamic-max-width {
        padding-left: 10px;
        max-width: 100%;
    }
}

.title-link {
    text-decoration: none;
}

.project-title {
    color: #202020;
}
</style>
